import React from 'react';

import { Button } from 'react-bulma-components/full';

import ModalCard from '../Modal/ModalCard';
import { WELCOME } from '../Language/es';

import './style.scss';

const WelcomeModal = ({ show, user, onClose }) => {
  const firstName = (user && user.account && user.account.first_name) || '';

  const body = (
    <div className="welcome-modal">
      <h3 className="welcome-modal__avisos-title">{WELCOME.AVISOS_TITLE}</h3>
      <ul className="welcome-modal__avisos">
        {WELCOME.AVISOS.map((aviso, i) => (
          <li key={i}>{aviso}</li>
        ))}
      </ul>
      <h3 className="welcome-modal__notes-title">{WELCOME.NOTES_TITLE}</h3>
      <ul className="welcome-modal__notes">
        {WELCOME.NOTES.map((note, i) => (
          <li key={i}>{note}</li>
        ))}
      </ul>
    </div>
  );

  const footer = (
    <Button color="primary" onClick={onClose}>
      {WELCOME.CONTINUE}
    </Button>
  );

  return (
    <ModalCard
      show={show}
      title={`${WELCOME.GREETING} ${firstName}`.trim()}
      body={body}
      footer={footer}
      closeModal={onClose}
      size="is-medium"
    />
  );
};

export default WelcomeModal;
